let PubSubModule = require("PubSub");

var pubsub: any = null;
if (!pubsub) {
  pubsub = new PubSubModule();
}

export default pubsub;
